/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Delete_Records_ConfirmInputs */



/**
* | output |
* | --- |
* | "Yes, delete them" |
*
* @param {Explorer_Display_Delete_Records_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_records_confirm = /** @type {((inputs?: Explorer_Display_Delete_Records_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Records_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, les supprimer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, lösche sie.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì, eliminali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Да, удалите их.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí, elimínalos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("是的，删除它们")
	if (locale === "ja") return /** @type {LocalizedString} */ ("はい、削除します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हां, उन्हें हटा दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sim, apague-os.")
	return /** @type {LocalizedString} */ ("Yes, delete them")
});